export default __webpack_public_path__ + "static/media/1213 spice rack top.d7e567d5.png";